import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import { ARTWORK_TYPE } from "../based/Constants";

function ListImageModal({ showImageModal, setShowImageModal, listImage, setListImage }) {
    const typeName = (type) => {
        switch (type) {
            case ARTWORK_TYPE.Front:
                return "Mặt trước";
            case ARTWORK_TYPE.Back:
                return "Mặt sau";
            case ARTWORK_TYPE.None:
                return "Ảnh đại diện";
            default:
                return "Không xác định";
        }
    };

    return (
        <CommonModal
            show={showImageModal}
            onClose={() => {
                setShowImageModal(false);
                setListImage([]);
            }}
            title={"Ảnh sản phẩm"}
            size="lg"
        >
            <Wrapper>
                <div className="mockup__slider">
                    {listImage.map((subImg, i) => (
                        <div key={i} className="image-mockup-slider">
                            <img src={subImg.url} alt="sub-image" />
                            <div className="type-name">{typeName(subImg.type)}</div>
                        </div>
                    ))}
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default ListImageModal;

const Wrapper = styled.div`
    .type-name {
        color: #444;
        text-align: center;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        position: relative;
    }
    .image-mockup-slider {
        width: 50%;
        height: auto;
    }

    .image-mockup-slider img {
        width: 100%;
        height: 100%;
    }

    .mockup__slider {
        display: flex;
    }
`;
